import React from "react"
import { Constant } from "../../helper/constant";
import { httpClient } from "../../helper/utils";

/**
 * @param {string} keyword
 */
async function getStaffAutocomplete(keyword) {
  const token = localStorage.getItem("token")
  const response = await httpClient(
    `${Constant.BASE_API_URL}/staf/autocomplete?keyword=${encodeURIComponent(keyword)}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.json();
}

/**
 * @param {string} keyword
 */
export function useStaffAutocomplete(keyword) {
  const [data, setData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [isError, setIsError] = React.useState(false)

  React.useEffect(() => {
    if (!keyword || keyword.length < 2) {
      setData([])
      setIsLoading(false)
      setIsError(false)
      return
    }

    async function fetchData() {
      setIsLoading(true)
      try {
        const result = await getStaffAutocomplete(keyword)
        setData(result.data.staffs)
        setIsLoading(false)
      } catch (error) {
        setData([])
        setIsLoading(false)
        setIsError(true)
      }
    }

    fetchData()
  }, [keyword])

  return { data, isLoading, isError }
}
